import RelationshipMetadata from "../../RelationshipMetadata";

class AdminRoleAdminPrivilegeRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "AdminRoleAdminPrivilegeRelationshipMetadata";
        this.parentEnterpriseComponent = "AdminRole";
        this.childEnterpriseComponent = "AdminRolePrivilege";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "RoleUSID";
    }
}

export default AdminRoleAdminPrivilegeRelationshipMetadata;